import type { Shadows } from './types';

export const shadows: Shadows = {
  '0': '0px 0px 4px rgba(0, 0, 0, 0.25)',
  '10': '0px 4px 16px rgba(0, 0, 0, 0.1)',
  '20': '0px 4px 24px rgba(0, 0, 0, 0.1)',
};
